import type { ReactNode } from "react";

/** Shared layout for the (scaffolded) legal pages. */
export function LegalPage({ eyebrow, title, children }: { eyebrow: string; title: string; children: ReactNode }) {
  return (
    <section>
      <div className="wrap" style={{ maxWidth: 760 }}>
        <div className="section-head">
          <p className="eyebrow">{eyebrow}</p>
          <h2>{title}</h2>
        </div>
        <div className="md">{children}</div>
      </div>
    </section>
  );
}
